import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'rating',
	prefix: 'rating',
	key: 'rating_id',
	fields: {
		rating_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		game_version_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		rating_date: Model.SCHEMA_DATE_CREATE,
		rating_value: Model.SCHEMA_NUMBER
	},
	methods: {
		get_rating: function() {
			return this.get_value()
		},
		to_array: function() {
			return {
				id: parseInt(this.get_id() || 0, 10),
				date: parseInt(this.get_date() || 0, 10),
				value: parseFloat(this.get_value() || 0),
				game: parseInt(this.get_game_id() || 0, 10),
				user: parseInt(this.get_user_id() || 0, 10)
			}
		}
	}
})
